import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UserManagementRoutingModule } from '@pg-app/client/user-management/user-management-routing.module';
import { UserManagementComponent } from '@pg-app/client/user-management/containers/user-management.component';

@NgModule({
    imports: [
        CommonModule,
        CoreMaterialModule,
        UserManagementRoutingModule,
        NgTableModule,
        ReactiveFormsModule,
    ],
    declarations: [UserManagementComponent]
})
export class UserManagementModule { }
